import React from "react";

export default function ReglementSkeleton({ variant = "card" }) {
  if (variant === "table") {
    return (
      <div className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="grid animate-pulse grid-cols-[1fr_160px_120px_280px] gap-4 border-b border-slate-200 px-4 py-4 last:border-b-0 dark:border-slate-800"
          >
            <div className="flex items-center gap-4">
              <div className="h-20 w-20 rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="space-y-2">
                <div className="h-3 w-28 rounded bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-64 rounded bg-slate-200 dark:bg-slate-800" />
                <div className="h-3 w-40 rounded bg-slate-200 dark:bg-slate-800" />
              </div>
            </div>

            <div className="h-8 w-28 self-center rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-6 w-20 self-center justify-self-end rounded bg-slate-200 dark:bg-slate-800" />
            <div className="flex justify-end gap-2 self-center">
              <div className="h-9 w-20 rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-9 w-28 rounded-2xl bg-slate-200 dark:bg-slate-800" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="animate-pulse overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-lg shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-950 dark:shadow-black/10">
      <div className="h-1 bg-slate-200 dark:bg-slate-800" />

      <div className="p-4">
        <div className="flex gap-3">
          <div className="h-24 w-24 rounded-2xl bg-slate-200 dark:bg-slate-800" />

          <div className="flex-1 space-y-3">
            <div className="h-3 w-32 rounded bg-slate-200 dark:bg-slate-800" />
            <div className="h-5 w-3/4 rounded bg-slate-200 dark:bg-slate-800" />
            <div className="h-3 w-1/2 rounded bg-slate-200 dark:bg-slate-800" />
            <div className="h-7 w-28 rounded-full bg-slate-200 dark:bg-slate-800" />
          </div>
        </div>

        <div className="mt-4 h-16 rounded-2xl bg-slate-200 dark:bg-slate-800" />
        <div className="mt-4 h-14 rounded-2xl bg-slate-300 dark:bg-slate-700" />
      </div>
    </div>
  );
}